import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../Reveal";

const ABSTRACT_IMG =
    "https://images.pexels.com/photos/31155280/pexels-photo-31155280.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Vision() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

    return (
        <section ref={ref} data-testid="vision-section" className="relative py-36 md:py-56 border-t hairline overflow-hidden">
            <motion.img
                src={ABSTRACT_IMG}
                alt=""
                aria-hidden
                style={{ y: bgY, scale: 1.25 }}
                className="absolute inset-0 w-full h-full object-cover opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#17151B] via-transparent to-[#17151B]" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <Reveal>
                    <p className="text-[16px] uppercase tracking-[0.1em] font-bold text-[#F3698F] mb-4">The bigger vision</p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2
                        data-testid="vision-statement"
                        className="font-serif-display font-light italic tracking-tight leading-[1.1] text-4xl md:text-6xl lg:text-7xl max-w-5xl"
                    >
                        Because women's healthcare will not be ignored now.
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="text-base md:text-lg text-[#D1C6DF] leading-relaxed max-w-xl mt-10">
                        Woman's health is far beyond just periods and tracking.
                        Femipal starts where the need is loudest, and grows into lifelong care which is catered just for you personally.
                        Making everything accessible and authentic for your health throughout your life.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}